import Vue from "vue";
import Vuex from "vuex";
import common from "./modules/common";
import auth from "./modules/auth";
import exchange from "./modules/exchange";
import activity from "./modules/activity";
import axios from "axios";
import router from "../router";

if (process.env.NODE_ENV === "development") {
  axios.defaults.baseURL = "http://localhost:8081/api";
} else {
  axios.defaults.baseURL = "/api";
}

Vue.use(Vuex);

axios.interceptors.response.use(
  res => {
    return res;
  },
  err => {
    if (err.response && err.response.status === 401) {
      localStorage.removeItem("user");
      auth.state.user = null;
      router.push({ name: "login" });
    }
    return Promise.reject(err);
  }
);

export default new Vuex.Store({
  modules: {
    common,
    auth,
    exchange,
    activity
  }
});
